// ============================================================
// API Configuration - Production Ready
// ============================================================

const isProduction = process.env.NODE_ENV === 'production';

// Use environment variable for API URL
const API_BASE_URL = isProduction 
    ? 'https://senidektechnologies.com/backend/api.php'
    : 'http://localhost/senidek-technology/backend/api.php';

export const API_CONFIG = {
    baseURL: API_BASE_URL,
    adminURL: isProduction
        ? 'https://senidektechnologies.com/backend/admin'
        : 'http://localhost/senidek-technology/backend/admin',
    endpoints: {
        contact: '?endpoint=contact',
        products: '?endpoint=products',
        contacts: '?endpoint=contacts',
        erpProjects: '?endpoint=erp-projects',
        testimonials: '?endpoint=testimonials',
        quotes: '?endpoint=quote',
    }
};

export default API_CONFIG;